import { render, staticRenderFns } from "./shuhada.vue?vue&type=template&id=2bdbeaa6&scoped=true"
import script from "./shuhada.vue?vue&type=script&lang=js"
export * from "./shuhada.vue?vue&type=script&lang=js"
import style0 from "./shuhada.vue?vue&type=style&index=0&id=2bdbeaa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdbeaa6",
  null
  
)

export default component.exports